<template>
  <crud-modal
    :show="show"
    :title="modalTitle"
    size="md"
    :loading="loading"
    :save-text="operation === 'delete' ? 'Borrar' : 'Guardar'"
    :save-variant="operation === 'delete' ? 'danger' : 'primary'"
    nested
    @save="onSave"
    @close="$emit('close')"
  >
    <div v-if="atributo">
      <div class="form-group mb-2">
        <label class="font-weight-bold small text-muted mb-0">Atributo:</label>
        <div>
          <strong>{{ atributo.atributo }}</strong>
        </div>
        <small v-if="descripcion" class="form-text text-muted">
          {{ descripcion }}
        </small>
      </div>

      <div class="form-group mb-2" v-if="operation !== 'create'">
        <label class="font-weight-bold small text-muted mb-0">Nivel con valor actual:</label>
        <div>
          <span class="badge badge-secondary">{{ atributo.nivel }}</span>
        </div>
      </div>

      <!-- Modo Borrar -->
      <div v-if="operation === 'delete'" class="form-group mb-2">
        <label class="font-weight-bold small text-muted mb-0">Valor a eliminar:</label>
        <div class="p-2 border rounded bg-light small font-mono">
          {{ atributo.valor || '(En blanco)' }}
        </div>
        <small class="form-text text-danger mt-1">
          Al borrar este atributo a este nivel, se heredará el valor configurado en los niveles inferiores (o Default).
        </small>
      </div>

      <!-- Modo Edición o Creación -->
      <div v-if="operation === 'edit' || operation === 'create'" class="form-group mb-2">
        <label for="atributoValorTextarea" class="font-weight-bold small text-muted mb-1">
          Valor {{ operation === 'create' ? 'nuevo' : 'heredado / actual' }}:
        </label>
        <textarea
          id="atributoValorTextarea"
          name="valor"
          v-model="localValor"
          class="form-control"
          :class="{ 'is-invalid': Boolean(errors) }"
          rows="3"
          placeholder="Ingrese el valor correspondiente al atributo..."
        ></textarea>
        <small class="form-text text-muted">
          Ingrese el texto, URL, identificador o valor numérico según la especificación del atributo.
        </small>

        <div v-if="atributo.atributo === 'billing_sequence_id'" class="alert alert-info py-2 px-3 mt-2 mb-2 small">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <i class="bi bi-diagram-3 mr-1"></i>
              <strong>Billing Sequence ID:</strong> {{ localValor || '(Sin seleccionar)' }}
            </div>
            <button
              type="button"
              class="btn btn-primary btn-sm py-0 px-2"
              @click="$emit('open-billing-selector')"
            >
              <i class="bi bi-list-check mr-1"></i>Seleccionar Secuencia
            </button>
          </div>
        </div>

        <div v-if="isAtributoCobro" class="alert alert-warning py-1 px-2 mt-2 mb-0 small">
          <i class="bi bi-exclamation-triangle-fill mr-1"></i>
          <strong>Advertencia:</strong> Se recomienda no editar los atributos asociados a cobros desde este panel para evitar inconsistencias.
        </div>
      </div>

      <div v-if="errors" class="alert alert-danger mt-3 mb-0 small" role="alert">
        {{ typeof errors === 'object' ? (errors.error || errors.message || JSON.stringify(errors)) : errors }}
      </div>
    </div>
  </crud-modal>
</template>

<script>
import CrudModal from "../utiles/CrudModal.vue";

export default {
  name: "AtributosFormModal",
  components: {
    CrudModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    operation: {
      type: String,
      default: "edit", // 'edit' | 'create' | 'delete'
    },
    atributo: {
      type: Object,
      default: null,
    },
    descripcion: {
      type: String,
      default: "",
    },
    initialValor: {
      type: [String, Number],
      default: "",
    },
    nivelTitle: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: [String, Object],
      default: null,
    },
  },
  data() {
    return {
      localValor: "",
    };
  },
  computed: {
    modalTitle() {
      const nivel = this.nivelTitle || "Default";
      if (this.operation === "delete") {
        return `Borrar atributo a Nivel ${nivel}`;
      }
      if (this.operation === "create") {
        return `Creando atributo a Nivel ${nivel}`;
      }
      return `Editar atributo a Nivel ${nivel}`;
    },
    isAtributoCobro() {
      if (!this.atributo || !this.atributo.atributo) return false;
      const cobroAttrs = [
        "billing_sequence_id",
        "sc_frequency",
        "sc_lifetime",
        "sc_payments",
        "sc_price",
        "restriction_bill",
        "sc_price_imp",
      ];
      return cobroAttrs.includes(this.atributo.atributo);
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.localValor = this.initialValor !== null && this.initialValor !== undefined ? this.initialValor : "";
      }
    },
    initialValor(val) {
      this.localValor = val !== null && val !== undefined ? val : "";
    },
  },
  methods: {
    onSave() {
      if (this.operation === "delete") {
        this.$emit("delete");
      } else {
        this.$emit("save", this.localValor);
      }
    },
  },
};
</script>

<style scoped>
.font-mono {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.85rem;
}
</style>
